import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Login from './pages/Login/Login';
import Signup from './pages/SignUp/SignUp';
import VerifyEmail from './pages/VerifyEmail/VerifyEmail';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import EnterpriseSignUp from './pages/EnterpriseSignUp/EnterpriseSignUp';
import PortalSelection from './pages/PortalSelection/PortalSelection';
import Redirect from './pages/Redirect/Redirect';
import ProtectedRoute from './components/ProtectedRoute';

export default function RouterProvider() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route
        path="/signup"
        element={<Signup />}
      />
      <Route
        path="/verify-email"
        element={<VerifyEmail />}
      />
      <Route
        path="/reset-password"
        element={<ResetPassword />}
      />
      <Route
        path="/enterprise-signup"
        element={<EnterpriseSignUp userType="enterprise" />}
      />
      <Route
        path="/investor-signup"
        element={<EnterpriseSignUp userType="investor" />}
      />
      <Route
        path="/portal-selection"
        element={
          <ProtectedRoute>
            <PortalSelection />
          </ProtectedRoute>
        }
      />
      <Route 
        path="/redirect" 
        element={<Redirect />} 
      />
      {/* Catch all unmatched routes */}
      <Route path="*" element={<h3 style={{ textAlign: 'center', marginTop: '24px' }}>Sorry, page not found</h3>} />
    </Routes>
  );
}
